import { render, staticRenderFns } from "./ShareLimitModal.vue?vue&type=template&id=6eddb2ca&scoped=true&"
import script from "./ShareLimitModal.vue?vue&type=script&lang=js&"
export * from "./ShareLimitModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareLimitModal.vue?vue&type=style&index=0&id=6eddb2ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eddb2ca",
  null
  
)

export default component.exports